import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  setStep({ commit }, value) {
    commit(types.SET_STEP, value)
    commit(types.SET_VISITED_STEP, value)
  },
  resetVisitedStep({ commit }, value) {
    commit(types.RESET_VISITED_STEP, value)
  },
  selectSubmodel({ commit }, id) {
    commit(types.SET_VEHICLE, id)
  },
  resetSubmodels({ commit }) {
    commit(types.RESET_SUBMODELS)
  },
  setSelectedChecklistItems({ commit }, data) {
    commit(types.SET_SELECTED_CHECKLIST_ITEMS, data)
  },
  async getScanProConfiguration({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getScanProConfiguration', () =>
      http.get('scanpro/ScanProConfiguration', {
        params: { id }
      })
    )
    commit(types.SET_SCANPRO_CONFIGURATION, r.data)
    return r.data
  },
  async decodeVin({ commit, dispatch }, vin) {
    const r = await startLoading(dispatch, 'decodeVin', () =>
      http.get('decoder/DecodeVin', {
        params: { vin }
      })
    )
    commit(types.SET_DECODED_VIN, { data: r.data, vin: vin })
    return r.data
  },
  async evaluateVehicle({ state, commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'evaluateVehicle', () =>
      http.post('scanpro/EvaluateVehicle', data)
    )
    commit(types.SET_RECOMMENDATION, r.data)
    return r.data
  },
  async saveScanProResults({ dispatch }, data) {
    const r = await startLoading(dispatch, 'saveScanProResults', () =>
      http.post('scanpro/SaveScanProResults', data)
    )
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/scanpro/actions.js